// Libraries
import dayjs from "dayjs";
import { Tooltip } from "@lockerpm/design";

// Components
import { TableDataCell } from "#src/common/Table";
import SeveritySelect from "#src/common/SeveritySelect";
import { SubStatusSelect } from "#src/common/SubStatusSelect";
import TooltipInnerWithCopy from "#src/common/TooltipInnerWithCopy";
import { getDomainFromUrl } from "#src/utils/common";

// API-related
import type {
  ILeakedDataSourceCodeDetails,
  ILeakedDataItem,
} from "#src/services/dataLeak";
import { TableRowWrapperAnchor } from "#src/common/Table/TableRowWrapper";
import { pathname } from "#src/config/pathname";
import { generatePath, createSearchParams } from "react-router-dom";
import { vulnerabilityStatusItemsForDataLeak } from "#src/config/filter/vulnerability";

interface IDataLeakSourceCodeTableRowProps {
  workspaceId: string;
  data: ILeakedDataItem<ILeakedDataSourceCodeDetails>;
  onChangeSeverity: (
    leakedData: ILeakedDataItem<ILeakedDataSourceCodeDetails>,
    severity: string
  ) => void;
  onChangeSubStatus: (
    leakedData: ILeakedDataItem<ILeakedDataSourceCodeDetails>,
    substatus: string
  ) => void;
}

const DataLeakSourceCodeTableRow = ({
  workspaceId,
  data,
  onChangeSeverity,
  onChangeSubStatus,
}: IDataLeakSourceCodeTableRowProps) => {
  return (
    <TableRowWrapperAnchor
      to={{
        pathname: generatePath(pathname.VULNERABILITIES, { workspaceId }),
        search: createSearchParams({
          assessment_type: "data_leak",
          vuln_id: data.vuln_id.toString(),
        }).toString(),
      }}
    >
      <TableDataCell>
        {data.details.repo ? (
          <Tooltip title={<TooltipInnerWithCopy value={data.details.repo} />}>
            <span className="overflow-hidden text-ellipsis">
              {getDomainFromUrl(data.details.repo)}
            </span>
          </Tooltip>
        ) : null}
      </TableDataCell>
      <TableDataCell className="justify-between">
        {data.details.commit ? (
          <Tooltip
            title={<TooltipInnerWithCopy value={data.source.join(", ")} />}
          >
            <span className="overflow-hidden text-ellipsis">
              {data.details.commit}
            </span>
          </Tooltip>
        ) : null}
      </TableDataCell>
      <TableDataCell>
        <SeveritySelect
          severityValue={data.severity ? data.severity.toUpperCase() : "NONE"}
          updateData={(severity) => {
            if (severity) {
              onChangeSeverity(data, severity);
            }
          }}
        />
      </TableDataCell>
      <TableDataCell>{data.keyword}</TableDataCell>
      <TableDataCell>
        <SubStatusSelect
          subStatusValue={data.sub_status}
          options={vulnerabilityStatusItemsForDataLeak}
          updateData={(substatus) => {
            if (substatus) {
              onChangeSubStatus(data, substatus);
            }
          }}
        />
      </TableDataCell>
      <TableDataCell>
        {data.reported_time
          ? dayjs.unix(data.reported_time).format("HH:mm DD.MM.YYYY")
          : "---"}
      </TableDataCell>
    </TableRowWrapperAnchor>
  );
};

export default DataLeakSourceCodeTableRow;
